export default __webpack_public_path__ + "static/Крысиные бега_26-b994fc3d0dda97d71e880d6ab7ac16ee.jpg";